module.exports = __webpack_public_path__ + "static/me.cb320835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/me.jpg
// module id = 533
// module chunks = 263791100135453